import { useMutation } from 'react-query';
import { feedbackService } from '../../../service/feedback.service';
import { ApiResponse } from '../../models/common';
import { FeedbackPayload } from '../../models/feedback';

export function useSubmitFeedback() {
  const mutation = useMutation<ApiResponse<void>, unknown, { payload: FeedbackPayload; images: File[] }>(
    ({ payload, images }) => feedbackService.submitFeedback(payload, images)
  );

  return {
    submitFeedback: mutation.mutateAsync,
    isSubmitting: mutation.isLoading,
    submitError: mutation.error,
  };
}
